import { render, staticRenderFns } from "./7-9table.vue?vue&type=template&id=7cffe653&scoped=true"
import script from "./7-9table.vue?vue&type=script&lang=js"
export * from "./7-9table.vue?vue&type=script&lang=js"
import style0 from "./7-9table.vue?vue&type=style&index=0&id=7cffe653&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cffe653",
  null
  
)

export default component.exports